import { useState } from "react";
import { useParams } from "react-router-dom";
import { TrashIcon } from "@heroicons/react/24/outline";
import EditItemBulk from "components/itemBulk/EditItemBulk";
import DeleteItem from "components/itemBulk/DeleteItem";
import Modal from "components/ui/modals";

export default function EditBulkItemPage() {
  const { id } = useParams();
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      {/* Delete Modal */}
      {showDeleteModal && (
        <Modal open={showDeleteModal} setOpen={setShowDeleteModal}>
          <DeleteItem
            id={id}
            onClose={() => setShowDeleteModal(false)}
          />
        </Modal>
      )}

      {/* Header */}
      <div className="sm:flex sm:items-center sm:justify-between mb-6">
        <div className="sm:flex-auto">
          <h1 className="font-semibold leading-6 text-3xl text-gray-900">
            Update Item (Bulk)
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            Edit the item details and manage combinations
          </p>
        </div>
        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button
            type="button"
            onClick={() => setShowDeleteModal(true)}
            className="rounded-md bg-red-600 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 flex items-center space-x-2"
          >
            <TrashIcon className="h-4 w-4" />
            <span>Delete Item</span>
          </button>
        </div>
      </div>

      {/* Form */}
      <EditItemBulk id={id} />
    </div>
  );
} 